import useRender from "../markdown/MarkdownRender.js";
import HostedImage from "../markdown/HostedImage.vue";

export default {
  install(app) {
    useRender(app);
    app.component('hosted-image', HostedImage);
  }
}